import { db, storage } from "./firebase";
import { collection, addDoc, onSnapshot, deleteDoc, doc, query, where, serverTimestamp, getDoc, updateDoc, getDocs, writeBatch, orderBy } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';

export const onMaterialsChange = (ownerId, callback) => {
    const materialsRef = collection(db, 'materials');
    
    // Only query for materials owned by the user. The client-side seeding of system materials was causing permission errors on deployment.
    const q = query(materialsRef, where("ownerId", "==", ownerId));

    const unsubscribe = onSnapshot(q, (snapshot) => {
        const materials = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Sort user-owned materials by creation date.
        const sortedMaterials = materials.sort((a, b) => {
            const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : 0;
            const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : 0;
            return dateB - dateA;
        });

        callback(sortedMaterials);
    }, (error) => {
        console.error("Error listening to material changes:", error);
        callback([]); // On error, return an empty array.
    });

    return unsubscribe;
};

export const addMaterial = (materialData) => {
    const materialsRef = collection(db, 'materials');
    return addDoc(materialsRef, {
        ...materialData,
        createdAt: serverTimestamp()
    });
};

export const updateMaterial = (materialId, data) => {
    const materialDocRef = doc(db, 'materials', materialId);
    return updateDoc(materialDocRef, data);
};

export const deleteMaterial = async (materialId, textureUrl) => {
    // Only attempt to delete from storage if the URL is a Firebase Storage URL
    if (textureUrl && textureUrl.includes('firebasestorage.googleapis.com')) {
        try {
            const textureRef = ref(storage, textureUrl);
            await deleteObject(textureRef);
        } catch (error) {
            if (error.code === 'storage/object-not-found') {
                console.warn("Texture not found in storage, but deleting reference from Firestore.");
            } else {
                // Log other storage errors but don't prevent Firestore deletion
                console.error("Error deleting texture from storage. Continuing to delete Firestore document.", error);
            }
        }
    }
    const materialDocRef = doc(db, 'materials', materialId);
    return deleteDoc(materialDocRef);
};


export const uploadTexture = (file, progressCallback, customPath) => {
    return new Promise((resolve, reject) => {
        const filePath = customPath || `materials/textures/${uuidv4()}-${file.name}`;
        const storageRef = ref(storage, filePath);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (progressCallback) progressCallback(progress);
            },
            (error) => {
                console.error("Upload failed:", error);
                reject(error);
            },
            async () => {
                try {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                } catch (error) {
                    console.error("Failed to get download URL:", error);
                    reject(error);
                }
            }
        );
    });
};
